import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { apiWorker } from '../api/worker';
import { Goal } from '../types';
import toast from 'react-hot-toast';

export const useGoals = (nodeId: string) => {
  return useQuery<Goal[]>({
    queryKey: ['goals', nodeId],
    queryFn: () => apiWorker.get(`/api/nodes/${nodeId}/goals`).then(r => {
      if (r.data && Array.isArray(r.data.content)) return r.data.content;
      return Array.isArray(r.data) ? r.data : [];
    }),
    enabled: !!nodeId,
  });
};

export const useCreateGoal = (nodeId: string) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: Partial<Goal>) => 
      apiWorker.post(`/api/nodes/${nodeId}/goals`, data).then(r => (r.data && Array.isArray(r.data.content)) ? r.data.content : r.data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['goals', nodeId] });
      toast.success('Goal created successfully');
    },
    onError: (error: any) => {
      toast.error(error.response?.data?.message || 'Failed to create goal');
    },
  });
};

export const useUpdateGoal = (nodeId: string) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ goalId, ...data }: { goalId: string } & Partial<Goal>) => 
      apiWorker.patch(`/api/nodes/${nodeId}/goals/${goalId}`, data).then(r => (r.data && Array.isArray(r.data.content)) ? r.data.content : r.data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['goals', nodeId] });
      toast.success('Goal updated successfully');
    },
    onError: (error: any) => {
      toast.error(error.response?.data?.message || 'Failed to update goal');
    },
  });
};
